export default __webpack_public_path__ + "static/media/news2402295.33059556.jpg";